import { routes } from "schemas/routes";

import { INSTAGRAM_ONBOARDING_FLOW } from "utils/localStorage";

import { InstagramOnboardingFlowOption } from "./schema";

export const instagramOnboardingNavigate = (
  currentPathname: string,
  direction: "next" | "back",
) => {
  const pageOrders = [
    routes.preferencesInstagramOnboarding,
    routes.aboutInstagramOnboarding,
    routes.categoryInstagramOnboarding,
  ];
  const currentPageIndex = pageOrders.findIndex((page) =>
    currentPathname.endsWith(page),
  );

  if (currentPageIndex === -1) {
    return routes.preferencesInstagramOnboarding;
  }
  if (direction === "next") {
    if (currentPageIndex === pageOrders.length - 1) {
      return `/${routes.dashboard}`;
    }
    return pageOrders[currentPageIndex + 1];
  } else {
    if (currentPageIndex === 0) {
      return routes.preferencesInstagramOnboarding;
    }
    return pageOrders[currentPageIndex - 1];
  }
};

export const isInSocialFlow = () => {
  const storedLocal = localStorage.getItem(INSTAGRAM_ONBOARDING_FLOW);
  return (
    storedLocal === InstagramOnboardingFlowOption.social ||
    storedLocal === InstagramOnboardingFlowOption.standard
  );
};
